import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { AiRecommendationsJob } from './api.graphql';
import type { AiRecommendationsJobQuery, AiRecommendationsJobQueryVariables } from './api.graphql';

export type AiPetitionRecommendationsJobResult =
	| { status: 'ERROR'; errorReason: string }
	| { status: 'IN_PROGRESS' }
	| { status: 'COMPLETED'; recommendations: Array<{ id: string; recommendation: string; why: string }> };

export async function aiPetitionRecommendations(
	responseId: string | null | undefined,
	utilityContext: UtilityContext,
): Promise<AiPetitionRecommendationsJobResult> {
	const {
		gql: { fetch },
		tracker,
		errorReporter,
	} = utilityContext;

	try {
		if (!responseId) {
			throw new Error('Failed to get petition recommendations job: No responseId provided');
		}

		const { data } = await fetch<AiRecommendationsJobQuery, AiRecommendationsJobQueryVariables>({
			query: AiRecommendationsJob,
			variables: { input: { responseId } },
			rejectOnError: true,
		});

		if (data.getAiPetitionRecommendationsJob.__typename === 'AiPetitionRecommendationsJobError') {
			throw new Error(`Failed to get petition recommendations job: ${data.getAiPetitionRecommendationsJob.reason}`, {
				cause: data.getAiPetitionRecommendationsJob.reason,
			});
		}

		if (data.getAiPetitionRecommendationsJob.__typename === 'AiPetitionRecommendationsJobInProgress') {
			return { status: 'IN_PROGRESS' };
		}

		void tracker.track('sap_ai_petition_recommendations_generate_loaded');

		return { status: 'COMPLETED', recommendations: [...data.getAiPetitionRecommendationsJob.recommendations] };
	} catch (e: unknown) {
		void tracker.track('sap_ai_petition_recommendations_generate_error');

		const error = e instanceof Error ? e : new Error('An unknown error occurred', { cause: e });

		void errorReporter.report(error, { severity: 'error' });
		throw error;
	}
}
